module.exports = __webpack_public_path__ + "img/syewm.efbd5603.jpg";